<template>
  <v-app class="container">
    <barra />
    <v-card v-if="show"  class="text-center" id="pdf" ref="pdf">
      <v-card-title class="grey lighten-4 change-font" primary-title>
        <v-container fluid grid-list-xl>
          <v-layout row wrap>
            <v-flex xs6 md6 sm6>Avance por Sector</v-flex>
            <v-flex xs6 md6 sm6>
              <div v-if="!UsuarioDetalleSector">Sector: {{nombresector}}</div>
              <div v-if="UsuarioDetalleSector">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <div v-on="on">
                      <v-select
                        :items="gsectores"
                        v-model="Sectorselected"
                        item-text="nombre"
                        item-value="idsector"
                        label="Sector *"
                      ></v-select>
                    </div>
                  </template>
                  <span>Seleccione el sector a consultar</span>
                </v-tooltip>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-title>
      <v-card-text>
        <v-container v-if="showgrafica" grid-list-xl>
          <div class="row mb-5">
            <div class="col text-center">
              <span class="convention">
                <span class="text-center titulo_punto" v-for="(item, index) in gsemaforos" :key="index">
                  <span class="point" :style="{backgroundColor:item.color}" >
                  </span> 
                  {{item.valorinicio}} - {{item.valorfinal}}%
                </span>

              </span>
            </div>
          </div>

          
          <div class="row pt-4 text-center">
            <div class="col-6  pl-0 pt-0" :id="'punto_' + item.idpunto" v-for="(item, index) in gpuntos" :key="index">
              
              <span class="titulo_punto bb" :style="'border-bottom-color:' + item.color"> 
                <img width="50px" class="d-inline-block gray" v-bind:src="'data:image/jpeg;base64,' + item.icono" />  
                {{ item.nombre }} 
              </span>
               <span class="titulo_punto bb d-inline" :style="'border-bottom-color:' + item.color"><span class="ml-5" :style="'font-size:1.5rem'">{{ obteneravance(item) }}%</span></span>
              <div class="chart text-center" :id="'chart_' + item.idpunto"></div>
            </div>
          </div>

          <div class="row mt-2">
            <div class="col text-center">
              <span class="convention">
                <span class="text-center titulo_punto" v-for="(item, index) in gsemaforos" :key="index">
                  <span class="point" :style="{backgroundColor:item.color}" >
                  </span> 
                  {{item.valorinicio}} - {{item.valorfinal}}%
                </span>
                
              </span>
            </div>
          </div>

          
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn color="primary" v-on="on" @click="exportar">Exportar</v-btn>
            </template>
            <span>Se descargarán los tableros de todos los sectores y entidades.</span>
          </v-tooltip>
          <v-flex
            class="fechacorte"
            xs12
            v-if="gfechacorte!== null"
          >Fecha actualización: {{formato(gfechacorte.fechaactualizacion)}}</v-flex>
          <v-flex
            class="fechacorte"
            xs12
            v-if="gfechacorte!== null"
          >Fecha corte: {{formato(gfechacorte.fechacorte)}}</v-flex>
        </v-container>
        <div v-if="!showgrafica">{{gnodata}}</div> 
      </v-card-text>
    </v-card>
    <v-dialog v-model="dialog" width="1100"  persistent>  
      <v-card height="800" v-show="!cargandotodossectores && !pintotodossectores">
        <v-card-title  class="grey lighten-4 change-font" primary-title>
          Exportar
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" @click="initgraficarpuntostodossectores" text>Cargar Datos</v-btn>
          <v-btn color="green darken-1" @click="pdfsectorial" text>Exportar</v-btn>
          <v-btn color="green darken-1" @click="cerrarvisorpdftodos" text>Cerrar</v-btn>
        </v-card-title>
        </v-card>
        <v-card height="800" v-show="cargandotodossectores && !pintotodossectores" >
          <v-card-title class="grey lighten-4 change-font" primary-title>
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
            Cargando &#8230;
          </v-card-title>
        </v-card>
        <v-card height="800" v-show="generandopdftodos" >
          <v-card-title class="grey lighten-4 change-font" primary-title>
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
            Generando pdf &#8230;
          </v-card-title>
        </v-card>
        <v-card v-show="!generandopdftodos && !cargandotodossectores && pintotodossectores">
          <v-card-title class="headline grey lighten-2" primary-title>
            Exportar
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" @click="initgraficarpuntostodossectores" text>Cargar Datos</v-btn>
            <v-btn color="green darken-1" @click="pdfsectorial" text>Exportar</v-btn>
            <v-btn color="green darken-1" @click="cerrarvisorpdftodos" text>Cerrar</v-btn>
          </v-card-title>

          <v-card-text>
            <div v-show="pintotodossectores" v-for="(sector, index) in gsectores" :key="index">
              {{sector.nombre}}
              <div class="row pt-4 text-center">
                <div class="col-6  pl-0 pt-0" :id="'puntotodos_' + sector.idsector + '_' + punto.idpunto" v-for="(punto, index) in gpuntos" :key="index">
                  
                  <span class="titulo_punto bb" :style="'border-bottom-color:' + punto.color"> 
                    <img width="50px" class="d-inline-block gray" v-bind:src="'data:image/jpeg;base64,' + punto.icono" />  
                    {{ punto.nombre }}
                  </span>
                  <span class="titulo_punto bb d-inline" :style="'border-bottom-color:' + punto.color" ><span class="ml-5" :style="'font-size:1.5rem'"> {{ obteneravanceporsector(punto, sector) }} %</span></span>
                  <div class="chart text-center" :id="'charttodos_' + sector.idsector + '_' + punto.idpunto"></div>
                </div>
              </div>
            </div>
          </v-card-text>
          
      </v-card>
    </v-dialog>
    <v-dialog v-model="showIndicadores" width="70%" persistent>
			<v-card>
        <v-flex>
          <v-card-title>
            <v-btn icon @click="showIndicadores = false" right>
              <v-icon>close</v-icon>
            </v-btn>
          <span class="popup-titulo">{{ titulopopupindicadores }}</span>  
          </v-card-title>
        </v-flex>
				<v-card-text>
          
					<v-data-table no-data-text="Sin datos" :headers="headers" :items="indicadores" class="elevation-2" hide-default :items-per-page="5">
            <template v-slot:item.avance="{ item }">
              {{ Intl.NumberFormat("es-CO", {minimumFractionDigits: 1}).format(item.avance) + " %" }}
            </template>
						<template v-slot:item.action="{ item }">
							<v-icon small class="mr-2" @click="detalle(item)">remove_red_eye</v-icon>
						</template>
            <template v-slot:footer>
              <v-row>
                <v-col xs12 sm12 m12>
                  <div id="div1" style="width:5%;float:right" >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <download-excel
                          id="div2"
                          style="width:100%;text-align: right;"
                          v-show="indicadores.length > 0"
                          class="btn btn-default"
                          :data="indicadores"
                          :exportFields="exportable"
                          name="Indicadores_Entidad.xls"
                          type="xls"
                          worksheet="Información"
                          :title= titulopopupindicadores
                        >
                          <v-icon
                            color="secondary"
                            v-on="on"
                            large
                            elevation="2"
                            >mdi-file-download-outline</v-icon
                          >
                        </download-excel>
                      </template>
                      <span>Descargar</span>
                    </v-tooltip>
                  </div>
                </v-col>
              </v-row>
            </template>
					</v-data-table>
				</v-card-text>
			</v-card>
		</v-dialog>
  </v-app>
</template>
<script>
import "@/assets/styles/pdet.scss";
import barra from "@/components/content/barra-nav.vue";
import { mapActions, mapGetters } from "vuex";
import store from "../../stores/index.js";
import moment from "moment";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
am4core.useTheme(am4themes_animated);
am4core.options.autoSetClassName = true;
import _ from 'lodash';


export default {
  data() {
    return {
      showIndicadores: false,
      indicadores: [],
      nombresector: "",
      UsuarioDetalleSector: false,
      OpcionesFiltrados: [],
      Sectorselected: 0,
      showgrafica: true,
      ExtructuraTabla: [],
      ShowFileds: [],
      chart: undefined,
      CharData: [],
      contentpdf: "",
      makeimagepdf: undefined,
      filtroselect: "",
      periodosselect: "",
      sectorfilter: "",
      currentpath: "",
      charts: [],
      chartstodos: [],
      chartssector: [],
      dialog: false,
      pintotodossectores: false,
      cargandotodossectores: false,
      generandopdftodos: false,
      titulopopupindicadores :'',
      headers: [
        { text: "Código", value: "codigo", fixed: true, width: "100px" },
        { value: "nombre", text: "Nombre", width: "65%" },
        {
          value: "avance",
          align: "right",
          text: "Avance",
          width: "110px",
        },
        { text: "Detalle", value: "action", sortable: false, align: "center", width: "100px" },
      ],
      exportable: {
        Codigo: "codigo",
        Nombre: "nombre",
        Avance: { 
            field: "avance", 
            callback: (value) => { return ` ${Intl.NumberFormat("es-CO", { maximumFractionDigits: 2 }).format(value)}`; },
                            },
      },
      semaforo:
        "data:image/png;base64, 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"
    };
  },
  components: {
    barra
  },
  created() {
     this.currentpath = this.$route.fullPath;
     this.get_semaforos();
     
    this.puntoTodos({
      params: {
        periodoId: this.gperiodo
      }
    });
    this.get_sectoresfiltrados();
    this.cargardatos();
    
  },
  // mounted() {
  //   this.limpiarcharts();
  //   self.charts = [];
  // },
  beforeDestroy() {
    this.limpiarcharts();
  },
  updated() {
    var ref = this;
    this.$nextTick(function () {
      if(this.gpuntos && document.getElementById("chart_" + this.gpuntos.length) != null){
          ref.graficar_puntos();
      }
    })
  },
  methods: {
    ...mapActions([
      "get_entidaddetallesector",
      "get_entidaddetallesectorPDF",
      "puntoTodos",
      "get_sectoresfiltrados",
      "get_semaforos",
      "get_fechacortesector",
      "get_porusuario",
      "Getperiodo",
      "get_puntossector",
      "get_puntosavanceAllsector",
      "get_puntosentidad"
    ]),
    detalle(item) {
      let global = JSON.parse(unescape(process.env.PACKAGE_JSON)).global;
      let env = global[global.env];
      this.$aes.setKey(env.path.secret);
      console.log(env.path.secret);
      let cifra = this.$aes.encrypt(item.idindicador.toString());
      let temporal =
        Math.random()
          .toString(36)
          .substring(2, 6) +
        cifra +
        Math.random()
          .toString(36)
          .substring(2, 6);
      let encrypted = this.$aes.encrypt(temporal);
      encrypted = encrypted.replace(/\//g, "AbcYq");
      encrypted = encrypted.replace(/\+/g, "qYcbA");
      this.$router.push("/detallepublicoindicador/" + encrypted);
    },
    cerrarvisorpdftodos()
    {
      this.dialog = false;
      
    },
    obteneravance(punto){
      if(this.gpuntoscategoria !=  undefined && this.gpuntoscategoria.filter(x => x.idpunto == punto.idpunto) != undefined)
      {
        let avance  = this.gpuntoscategoria.filter(x => x.idpunto == punto.idpunto)
        if(avance.length > 0)
          return avance[0].avance;
      }
      else
        return "";
    },
    obteneravanceporsector(punto, sector){
      let registro = this.gpuntosavancesAllsectores !=  undefined && this.gpuntosavancesAllsectores.filter(x => x.idpunto == punto.idpunto && x.idsector == sector.idsector);
      if(registro != undefined && registro.length > 0)
      {
        return registro[0].avance;
      }
      else
        return "";
    },
    limpiarcharts(){
      if(this.charts.length > 0)
      {
        for (var i = 0; i <= this.charts.length-1; i++) {
          let chart = this.charts[i].chart;
          chart.dispose();
        }
      }
      if(this.chartstodos.length > 0)
      {
        for (var i = 0; i <= this.chartstodos.length-1; i++) {
          let chart = this.chartstodos[i].chart;
          chart.dispose();
        }
      }
    },
    cargardatos() {
      this.get_porusuario();
      if (!this.UsuarioDetalleSector) {
        this.Sectorselected = this.datousuario().idsector;
      }
      this.get_entidaddetallesector({
        params: {
          idperiodo: this.gperiodo,
          idsector: this.Sectorselected
        }
      });
      this.get_entidaddetallesectorPDF({
        params: {
          idperiodo: this.gperiodo
        }
      });
      this.get_puntossector({
        params: {
          periodoId: this.gperiodo,
          idsector: this.Sectorselected
        }
      });
      
      this.get_fechacortesector({
        params: {
          idperiodo: this.gperiodo,
          idsector: this.Sectorselected
        }
      });
    },
    color(progreso) {
      if (progreso > 100) {
        progreso = 100;
      }
      if(progreso > 99 && progreso < 100)
        progreso = Math.floor(progreso);

      if (this.gsemaforos.length === 0) {
        store.watch(
          () => store.getters["gsemaforos"],
          () => {
            return this.gsemaforos.filter(
              p => p.valorinicio <= progreso && p.valorfinal >= progreso
            )[0].color;
          }
        );
      } else {
        let semaforo = this.gsemaforos.filter(
          p => p.valorinicio <= progreso && p.valorfinal >= progreso
        )[0];
        return semaforo.color;
      }
    },
    datousuario() {
      return JSON.parse(unescape(localStorage.usuario));
    },
    formato(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY");
      }
    },
    async graficar_puntos() {
        let self = this;

        this.gpuntos.forEach((punto) => {

          let registroAvance =  this.gpuntoscategoria.filter(c => c.idpunto == punto.idpunto);
          let avancepunto = registroAvance != undefined &&  registroAvance.length > 0 ? registroAvance[0].avance : "";
            
          let data = [];
          let idx = punto.idpunto - 1;
            
          this.gentidades.forEach(async (entidad) => {
            
            if (entidad.puntos[idx] >= 0) {
              //console.log(entidad);
              data.push({
                  category: entidad.nombre,
                  value: entidad.puntos[idx],
                  full: 100,
                  punto: punto,
                  entidad: entidad,
                  indicadores: entidad.conteoIndicadores[idx],
                  listadoIndicadores: entidad.listadoIndicadores != undefined ? entidad.listadoIndicadores[idx] : []
              });
            }
          });
           
          let el = document.getElementById("punto_" + punto.idpunto);
          el.classList.remove("hidden");
          if (data.length > 0) {
            let punto_id = punto.idpunto;
            let el = document.getElementById("chart_" + punto_id);
            
           
              let chart = am4core.create("chart_" + punto_id, am4charts.GaugeChart);
              chart.data = [];
              chart.startAngle = -90;
              chart.endAngle = 180;
              chart.innerRadius = am4core.percent(10);
              chart.numberFormatter.numberFormat = "#.#";

              let categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
              categoryAxis.dataFields.category = "category";
              categoryAxis.renderer.grid.template.dy = 150;
              categoryAxis.renderer.grid.template.location = 0;
              categoryAxis.renderer.grid.template.strokeWidth = 0;
              categoryAxis.renderer.grid.template.strokeOpacity = 0;
              let label = categoryAxis.renderer.labels.template;
              label.horizontalCenter = "right";
              label.fontWeight = 500;
              label.truncate = true;
              label.maxWidth = 380;
              categoryAxis.renderer.labels.template.adapter.add("fill", function(fill, target) {
                  return am4core.color("#333");
              });
              categoryAxis.renderer.minGridDistance = 0;

              let valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
              valueAxis.renderer.labels.template.disabled = true;
              valueAxis.renderer.grid.template.strokeOpacity = 0;
              valueAxis.min = 0;
              valueAxis.max = 100;
              valueAxis.strictMinMax = true;

              let series1 = chart.series.push(new am4charts.RadarColumnSeries());
              series1.dataFields.valueX = "full";
              series1.dataFields.categoryY = "category";
              series1.clustered = false;
              series1.columns.template.fill = new am4core.InterfaceColorSet().getFor("alternativeBackground");
              series1.columns.template.fillOpacity = 0.05;
              series1.columns.template.cornerRadiusTopLeft = 0;
              series1.columns.template.strokeWidth = 0;
              series1.columns.template.radarColumn.cornerRadius = 5;
              series1.columns.template.tooltipText = "{category}: [bold]{value}[/]%";

              let series2 = chart.series.push(new am4charts.RadarColumnSeries());
              series2.dataFields.valueX = "value";
              series2.dataFields.categoryY = "category";
              series2.clustered = false;
              series2.columns.template.strokeWidth = 0;
              series2.columns.template.tooltipText = "{category}: [bold]{value}[/]% Número de Indicadores:[bold]{indicadores}";
              series2.columns.template.radarColumn.cornerRadius = 5;
              series2.columns.template.radarColumn.width = "10px";
              
              series2.columns.template.adapter.add("fill", function(fill, target) {
                  if (typeof target.dataItem.dataContext !== "undefined") {
                      return am4core.color(self.color(target.dataItem.dataContext.value));
                  }
              });

              series2.columns.template.events.on("hit", function(e) {
                console.clear();
                let data = e.target.dataItem.dataContext;
                self.indicadores = data.listadoIndicadores;
                console.log(self);
                self.titulopopupindicadores = `Sector: ${self.nombresector} / ${data.punto.nombre} / Entidad: ${data.entidad.nombre}`;
                self.showIndicadores = true;
              });

              series1.columns.template.events.on("hit", function(e) {
                console.clear();
                let data = e.target.dataItem.dataContext;
                self.indicadores = data.listadoIndicadores;
                self.titulopopupindicadores = `Sector: ${self.nombresector} / ${data.punto.nombre} / Entidad: ${data.entidad.nombre}`;
                self.showIndicadores = true;
              });

              series1.tooltip.label.adapter.add("text", function(text, target) {
                if (target.dataItem.dataContext && target.dataItem.dataContext.value == 0) {
                  return text + " Número de Indicadores: {indicadores}";
                }
                else
                  return "";
              });

              series2.tooltip.background.pointerLength = 0;
              el.classList.remove("hidden");

              self.charts.push({chart:chart, nombre:punto.nombre, icono:punto.icono, avance: avancepunto});
              self.graficar(data, chart);
            
          }
          else
            el.classList.add("hidden");
            
        });
    },
    graficar_puntos_todos_sectores() {
        let self = this;
        this.get_puntosavanceAllsector({
          params: {
            periodoId: this.gperiodo,
          }
        }).then(function(){
          self.gsectores.forEach(
          (sector)=>{
            self.gpuntos.forEach((punto) => {
              let registroAvance = self.gpuntosavancesAllsectores.filter(c => c.idsector == sector.idsector && c.idpunto == punto.idpunto);
              let avancepuntosector = registroAvance != undefined &&  registroAvance.length > 0 ? registroAvance[0].avance : " ";
            
                let data = [];
                let idx = punto.idpunto - 1;
                var entidadessector = self.gentidadesPDF.filter(x => x.idsector == sector.idsector);

                entidadessector.forEach((entidad) => {
                    if (entidad.puntos[idx] >= 0) {
                        data.push({
                            category: entidad.nombre,
                            value: entidad.puntos[idx],
                            full: 100,
                            punto: punto,
                            entidad: entidad,
                            indicadores: entidad.conteoIndicadores != null ? entidad.conteoIndicadores[idx] : 0
                        });
                    }
                });
                let el = document.getElementById("puntotodos_" + sector.idsector + '_' + punto.idpunto);
                el.classList.remove("hidden");
                if (data.length > 0) {
                  let el = document.getElementById("charttodos_"  + sector.idsector + '_' + punto.idpunto);
                  
                  let chartexiste = false;
                  let chartsrendered = am4core.registry.baseSprites;
                  for(let i = 0; i <= chartsrendered.length-1; i++) {
                    if (chartsrendered[i].htmlContainer.id == "charttodos_"  + sector.idsector + '_' + punto.idpunto) {
                      chartexiste = true;
                    }
                  }
                  if(!chartexiste)
                  {
                    let chart = am4core.create("charttodos_" +  sector.idsector + '_' + punto.idpunto, am4charts.GaugeChart);
                    chart.data = [];
                    chart.startAngle = -90;
                    chart.endAngle = 180;
                    chart.innerRadius = am4core.percent(10);
                    chart.numberFormatter.numberFormat = "#.#";

                    let categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
                    categoryAxis.dataFields.category = "category";
                    categoryAxis.renderer.grid.template.dy = 150;
                    categoryAxis.renderer.grid.template.location = 0;
                    categoryAxis.renderer.grid.template.strokeWidth = 0;
                    categoryAxis.renderer.grid.template.strokeOpacity = 0;
                    let label = categoryAxis.renderer.labels.template;
                    label.horizontalCenter = "right";
                    label.fontWeight = 500;
                    label.truncate = true;
                    label.maxWidth = 380;
                    categoryAxis.renderer.labels.template.adapter.add("fill", function(fill, target) {
                        return am4core.color("#333");
                    });
                    categoryAxis.renderer.minGridDistance = 0;

                    let valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
                    valueAxis.renderer.labels.template.disabled = true;
                    valueAxis.renderer.grid.template.strokeOpacity = 0;
                    valueAxis.min = 0;
                    valueAxis.max = 100;
                    valueAxis.strictMinMax = true;

                    

                    let series1 = chart.series.push(new am4charts.RadarColumnSeries());
                    series1.dataFields.valueX = "full";
                    series1.dataFields.categoryY = "category";
                    series1.clustered = false;
                    series1.columns.template.fill = new am4core.InterfaceColorSet().getFor("alternativeBackground");
                    series1.columns.template.fillOpacity = 0.05;
                    series1.columns.template.cornerRadiusTopLeft = 0;
                    series1.columns.template.strokeWidth = 0;
                    series1.columns.template.radarColumn.cornerRadius = 5;
                    series1.columns.template.tooltipText = "{category}: [bold]{value}[/]%";
                  

                    let series2 = chart.series.push(new am4charts.RadarColumnSeries());
                    series2.dataFields.valueX = "value";
                    series2.dataFields.categoryY = "category";
                    series2.clustered = false;
                    series2.columns.template.strokeWidth = 0;
                    series2.columns.template.tooltipText = "{category}: [bold]{value}[/]% Número de Indicadores: {indicadores}";
                    series2.columns.template.radarColumn.cornerRadius = 5;
                    series2.columns.template.radarColumn.width = "10px";
                    
                    series2.columns.template.adapter.add("fill", function(fill, target) {
                        if (typeof target.dataItem.dataContext !== "undefined") {
                            return am4core.color(self.color(target.dataItem.dataContext.value));
                        }
                    });

                    series1.tooltip.label.adapter.add("text", function(text, target) {
                      if (target.dataItem.dataContext && target.dataItem.dataContext.value == 0) {
                        return text + "Número de Indicadores: {indicadores}";
                      }
                      else
                        return "";
                    });

                    series2.tooltip.background.pointerLength = 0;
                     el.classList.remove("hidden");

                    self.chartstodos.push({chart:chart, idpunto: punto.idpunto, nombre:punto.nombre, icono:punto.icono, sector:sector.nombre, idsector: sector.idsector, avance: avancepuntosector});
                    self.graficar(data, chart);
                  }
                }
                else
                   el.classList.add("hidden");
            });

          }
        )
        self.pintotodossectores = true;
        self.cargandotodossectores = false;
        });
        
    },
    graficar(data, chart) {
        chart.data = data.sort((a, b) => (a.value > b.value ? 1 : b.value > a.value ? -1 : 0));
        chart.innerRadius = am4core.percent(100 - chart.data.length * 13);
        chart.validateData();
        let ce = chart.element.node;

        setTimeout(function() {
            ce.setAttribute("transform", "translate(110,10)");
        }, 10);
    },
    initgraficarpuntostodossectores()
    {
      this.cargandotodossectores=true;
      setTimeout(this.graficar_puntos_todos_sectores, 100);
    },
    generarcontenidobase(){
      let locallogo = this.glogo;
      let fecha = this.$getFormattedDate();

      this.gbotones.forEach(element => {
        if (element.state == true) {
          this.filtroselect = element.caption;
        }
      });

      this.periodosselect = "";
      if (this.gperiododata.nombre != undefined) {
        this.periodosselect = " => " + this.gperiododata.nombre;
      }

      this.contentpdf = {
        pageOrientation: "landscape",
        pageMargins: [30, 30, 30, 30],
        content: [
          { image: locallogo, width: 150 },
          { text: "Avance Sectorial PMI \n\n", style: "header" },
          {
            text:
              "Filtros:  " + this.filtroselect + " " + this.periodosselect,
            style: "textfilter",
          },
        ],
        styles: {
          tableStyle: {
            width: "100%",
          },
          header: {
            fontSize: 20,
            bold: true,
            alignment: "center",
          },
          subheader: {
            fontSize: 18,
            bold: true,
            alignment: "left",
          },
          tableHeader: {
            bold: true,
            fontSize: 14,
            color: "black",
            alignment: "center",
            "background-color": "#4CAF50",
          },
          textfilter: {
            fontSize: 15,
            bold: false,
            alignment: "right",
          },
          textright:{
            alignment: "right"
          }
        },
        footer: function (currentPage, pageCount) {
          return [
            {
              text: fecha,
              alignment: "left",
              margin: [10, 0],
              fontSize: 8,
            },
            {
              text: "Página " + currentPage.toString() + " de " + pageCount,
              alignment: "right",
              margin: [10, 0],
              fontSize: 8,
            },
          ];
        },
      };
    },
    exportar(){
      if (this.UsuarioDetalleSector) {
        this.dialog = true;
      }
      else
        this.pdfsectorial();
    },
    async pdfsectorial() {
      let self = this;
      this.generandopdftodos = true;

      if(!self.UsuarioDetalleSector)
        self.chartstodos = self.charts;

      var pdfMake;
      let generarImagenesPromise = new Promise(async function(resolve, reject) {
        pdfMake = await self.chartstodos[0].chart.exporting.pdfmake;
        for(let x=0;x <= self.chartstodos.length-1; x++)
        {
          self.chartstodos[x].image = await self.chartstodos[x].chart.exporting.getImage("png");
        }
        resolve();
      });

      generarImagenesPromise.then(function(){

        function buildTableBody() {
          var body = [];
          
          let cols = 3;
          let rows = parseInt((self.chartssector.length / cols) + (self.chartssector.length % cols));
          for(let row=0;row <= (rows*2)-1; row++)
          {
            var dataRow = [];
            
            for(let col=0;col<=cols-1;col++)
            {
              let numchart = parseInt((row/2))*cols+(col+1);
                              
              if(row % 2 == 0)
              {
                if(self.chartssector[numchart-1]!= undefined){
                  
                  dataRow.push({columns: [{ image: 'data:image/jpeg;base64,' + self.chartssector[numchart-1].icono, width: 20}, {text: self.chartssector[numchart-1].nombre, alignment:'center'},{text:' '},{text: self.chartssector[numchart-1].avance + '%' }], alignment:'center'});
                }
                else
                  dataRow.push("");
              }
              else
              {
                if( self.chartssector[numchart-1] != undefined)
                  dataRow.push({ image: self.chartssector[numchart-1].image, width: 230,  pageBreak: 'after' });
                else
                  dataRow.push("");
              }
            }
            body.push(dataRow);
          
          }
          
          return body;
        }

        function generatetable() {
          return {
            table: {
              headerRows: 0,
              widths: [250, 250, 250],
              body: buildTableBody(),
              alignment: "center"
            },
            layout: {
              hLineWidth: function() {
                return 0;
              },
              vLineWidth: function() {
                return 0;
              }
            }
          };
        }

        self.generarcontenidobase();
        
        if(self.UsuarioDetalleSector) {
          self.gsectores.forEach(element => {
            self.chartssector=self.chartstodos.filter(record => {
              if(record.idsector==element.idsector) {
                self.sectorfilter=element.nombre;
                return record;
              }
            });
            
            if(self.chartssector.length>0) {
              self.contentpdf.content.push({
                text: "\n\n"+self.sectorfilter,
                style: "subheader"
              });

              self.contentpdf.content.push(
                generatetable()
              );
            }
          });
        } else {
          self.chartssector=self.chartstodos.filter(async (record) => {
            if(record.idsector==self.Sectorselected) {
              return record;
            }
          });
          if(self.chartssector.length>0) {
            self.contentpdf.content.push({
              text: "\n\n"+self.nombresector,
              style: "subheader"
            });
            self.contentpdf.content.push(
              generatetable()
            );
          }
        }
        
        pdfMake.createPdf(self.contentpdf).download("sectorial.pdf");      
        self.generandopdftodos = false;
      });
    }
  },
  computed: {
    ...mapGetters("mensaje", ["ginformation", "gnodata", "glogo"]),
    ...mapGetters([
      "gentidades",
      "gentidadesPDF",
      "gpuntos",
      "gsectores",
      "gsemaforos",
      "gfechacorte",
      "gopciones",
      "gperiododata",
      "gpuntoscategoria",
      "gpuntoscategoriaentidad",
      "gpuntosavancesAllsectores"
    ]),
    ...mapGetters("barra", ["gperiodo", "gbotones"]),
    ...mapGetters("mensaje", ["ginformation", "gnodata", "glogo"]),
    show: function() {
      return this.gpuntos && this.gentidades;
    }
  },
  watch: {
    gperiodo: function() {
      this.limpiarcharts();
      this.charts = [];
      this.cargardatos();
      this.Getperiodo({
        params: {
          idperiodo: this.gperiodo
        }
      });
    },
    Sectorselected: function() {
      let self = this;
      if (this.UsuarioDetalleSector) {
        this.nombresector = this.gsectores.filter(
          p => p.idsector === self.Sectorselected
        )[0].nombre;
      }
      

      this.limpiarcharts();
      this.charts = [];
      this.cargardatos();
    },
    gentidades: function() {
      if (this.gentidades.length > 0) {
        this.showgrafica = true;
      } else {
        this.showgrafica = false;
      }
    },
    gopciones: function() {
      //Validamos que tenemos el permiso de [Por sector]
      let SearchOpcion = this.gopciones.filter(record => {
        return record.titulo == "Tableros";
      });
      if (SearchOpcion.length > 0) {
        let HijosOpcion = SearchOpcion[0].hijos;
        let Subtitle = HijosOpcion.filter(record => {
          return record.link == this.currentpath;
        });
        if (Subtitle.length > 0) {
          HijosOpcion = [];
          HijosOpcion = Subtitle[0].hijos;
          Subtitle = [];
          Subtitle = HijosOpcion.filter(record => {
            return record.titulo == "Por sector";
          });
          this.OpcionesFiltrados = Subtitle;
          if (Subtitle.length > 0) {
            this.UsuarioDetalleSector = true;
          }
        }
      }
    },

    gsectores: function() {
      this.nombresector = this.gsectores.filter(
        p => p.idsector === this.datousuario().idsector
      )[0].nombre;
    }
  }
};
</script>